import { useOnlineStatus } from '../../hooks/useOnlineStatus';

export default function OfflineIndicator() {
  const isOnline = useOnlineStatus();

  return (
    <div className={`offline-indicator ${!isOnline ? 'show' : ''}`}>
      <i className="ri-wifi-off-line mr-2"></i>
      You are currently offline. Some features may be limited.
    </div>
  );
}
